<template>
<el-dialog :visible.sync="show" title="导入备注" width="410px">
  <div class="content">
    <div style="padding-bottom: 12px;">
      <el-button type="text" @click="downloadTemp">导入模版</el-button>
    </div>
    <div class="upload-wrap">
      <el-upload
        class="upload-demo"
        drag
        accept=".xls, .xlsx"
        :limit="1"
        :auto-upload="false"
        :file-list="fileList"
        :on-change="handleUploadChange"
        :on-remove="() => fileList = []"
        ref="upload"
        action="#">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">点击或拖拽上传文件</div>
        <div class="el-upload__tip" slot="tip">请先下载导入模版，填入数据后，再进行上传 <br />
          数量1，大小2M以内，支持格式xls,xlsx</div>
      </el-upload>
    </div>
  </div>

  <!-- 导入结果 -->
  <el-dialog :visible.sync="showRstDialog" append-to-body title="导入备注结果" width="410px">
    <div v-if="importRst" class="rst-content">
      <div>总上传<b> {{ importRst.totalNum }}</b> 条, 上传成功<b class="success-text"> {{ importRst.successNum }}</b> 条, 上传失败<b class="fail-text"> {{ importRst.failNum }}</b> 条</div>
      <div v-if="importRst.failList && importRst.failList.length" style="margin-top: 8px;">
        <div style="color: #999; font-size: 12px;">失败订单编号：</div>
        <div class="fail-list">{{ importRst.failList.join('、') }}</div>
      </div>
    </div>
    <div slot="footer">
      <el-button size="mini" @click="showRstDialog = false; $emit('on-success')">关闭</el-button>
    </div>
  </el-dialog>

  <div slot="footer">
    <el-button size="mini" @click="$emit('close')">关闭</el-button>
    <el-button size="mini" :disabled="!fileList.length" @click="submitUpload" type="primary">上传</el-button>
  </div>
</el-dialog>
</template>

<script>
import { getUserId } from '@/utils/getUser'

export default {
  name: 'importRemarkDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    show: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    }
  },
  data () {
    return {
      fileList: [],
      showRstDialog: false,
      importRst: null
    }
  },
  methods: {
    downloadTemp () {
      window.open(location.origin + '/template/导入备注模板.xlsx')
    },
    handleUploadChange (file) {
      this.fileList = [file]
    },
    submitUpload () {
      if (!this.fileList.length) return
      const file = this.fileList[0]
      if (file.size / 1024 / 1024 > 2) {
        this.$message.error('上传文件的大小不能超过2MB')
        this.fileList = []
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '导入中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.45)'
      })
      const formData = new FormData()
      formData.append('file', file.raw)
      this.$http('post', 'mall/bdOrderReport/importQdRemark', formData, false, false).then(res => {
        if (res) {
          this.fileList = []
          this.importRst = res
          this.showRstDialog = true
        }
      }).catch(() => {
        this.$message.error('导入模板有误或订单编号/备注未填全')
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>

<style scoped>
.content {
  line-height: 24px;
  font-size: 14px;
  color: #666;
}
.upload-wrap {
  padding-top: 16px;
}
.rst-content {
  font-size: 14px;
  line-height: 28px;
  color: #333;
}
.success-text {
  color: #67C23A;
}
.fail-text {
  color: #F56C6C;
}
.fail-list {
  font-size: 12px;
  color: #F56C6C;
  word-break: break-all;
  max-height: 120px;
  overflow-y: auto;
  margin-top: 4px;
}
</style>
